module.exports = __webpack_public_path__ + "static/Arvo-Regular-f61119f67a0baffd10c46bd94cef06ac.woff2";